import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
declare global {
  interface Window {
    fbq: any;
  }
}
// Lazy load all pages — only the visited route downloads
const LandingPage = lazy(() => import('./pages/LandingPage').then(m => ({
  default: m.LandingPage
})));
const ThankYouPage = lazy(() => import('./pages/ThankYouPage').then(m => ({
  default: m.ThankYouPage
})));
const ThankYouMPage = lazy(() => import('./pages/ThankYouMPage').then(m => ({
  default: m.ThankYouMPage
})));
const VslPage = lazy(() => import('./pages/VslPage').then(m => ({
  default: m.VslPage
})));
const VslIgPage = lazy(() => import('./pages/VslIgPage').then(m => ({
  default: m.VslIgPage
})));
const VslDisqualifyPage = lazy(() => import('./pages/VslDisqualifyPage').then(m => ({
  default: m.VslDisqualifyPage
})));
const UpSellDisqualifyPage = lazy(() => import('./pages/UpSellDisqualifyPage').then(m => ({
  default: m.UpSellDisqualifyPage
})));
const OptinVslPage = lazy(() => import('./pages/OptinVslPage').then(m => ({
  default: m.OptinVslPage
})));
const RetargetingPage = lazy(() => import('./pages/RetargetingPage').then(m => ({
  default: m.RetargetingPage
})));
const ConfirmationPage = lazy(() => import('./pages/ConfirmationPage').then(m => ({
  default: m.ConfirmationPage
})));
const ReplayPage = lazy(() => import('./pages/ReplayPage').then(m => ({
  default: m.ReplayPage
})));
const LloydPage = lazy(() => import('./pages/LloydPage').then(m => ({
  default: m.LloydPage
})));
const HeyLloydPage = lazy(() => import('./pages/HeyLloydPage').then(m => ({
  default: m.HeyLloydPage
})));
const HeyLloydCustomsPage = lazy(() => import('./pages/HeyLloydCustomsPage').then(m => ({
  default: m.HeyLloydCustomsPage
})));
const HeyLloydBookACallPage = lazy(() => import('./pages/HeyLloydBookACallPage').then(m => ({
  default: m.HeyLloydBookACallPage
})));
const WebinarReplyPage = lazy(() => import('./pages/WebinarReplyPage').then(m => ({
  default: m.WebinarReplyPage
})));
const WebinarReplyPageIndia = lazy(() => import('./pages/WebinarReplyPageIndia').then(m => ({
  default: m.WebinarReplyPageIndia
})));
const BookingQualificationPage = lazy(() => import('./pages/BookingQualificationPage').then(m => ({
  default: m.BookingQualificationPage
})));
const BookCallInternalPage = lazy(() => import('./pages/BookCallInternalPage').then(m => ({
  default: m.BookCallInternalPage
})));
const PrivacyPage = lazy(() => import('./pages/PrivacyPage').then(m => ({
  default: m.PrivacyPage
})));
const TermsPage = lazy(() => import('./pages/TermsPage').then(m => ({
  default: m.TermsPage
})));
const RegaloPage = lazy(() => import('./pages/RegaloPage').then(m => ({
  default: m.RegaloPage
})));
const MeditationsPage = lazy(() => import('./pages/MeditationsPage').then(m => ({
  default: m.MeditationsPage
})));
const LlamadaConfirmationPage = lazy(() => import('./pages/LlamadaConfirmationPage').then(m => ({
  default: m.LlamadaConfirmationPage
})));
const LlamadaAiPage = lazy(() => import('./pages/LlamadaAiPage').then(m => ({
  default: m.LlamadaAiPage
})));
const LlamadasSemanalesCursoPage = lazy(() => import('./pages/LlamadasSemanalesCursoPage').then(m => ({
  default: m.LlamadasSemanalesCursoPage
})));
const BookCallStrategyPage = lazy(() => import('./pages/BookCallStrategyPage').then(m => ({
  default: m.BookCallStrategyPage
})));
const WebinarJuevesNewPage = lazy(() => import('./pages/WebinarJuevesNewPage').then(m => ({
  default: m.WebinarJuevesNewPage
})));
const BreakoutVideoPage = lazy(() => import('./pages/BreakoutVideoPage').then(m => ({
  default: m.BreakoutVideoPage
})));
const ReplayOfferPage = lazy(() => import('./pages/ReplayOfferPage').then(m => ({
  default: m.ReplayOfferPage
})));
const CaseStudy1050Page = lazy(() => import('./pages/CaseStudy1050Page').then(m => ({
  default: m.CaseStudy1050Page
})));
const ComoIaPage = lazy(() => import('./pages/ComoIaPage').then(m => ({
  default: m.ComoIaPage
})));
const WelcomePage = lazy(() => import('./pages/WelcomePage').then(m => ({
  default: m.WelcomePage
})));
const HistoriaPage = lazy(() => import('./pages/HistoriaPage').then(m => ({
  default: m.HistoriaPage
})));
const LeadMagnetHeyLloydDemoPage = lazy(() => import('./pages/LeadMagnetHeyLloydDemoPage').then(m => ({
  default: m.LeadMagnetHeyLloydDemoPage
})));
const Faltan3DiasPage = lazy(() => import('./pages/Faltan3DiasPage').then(m => ({
  default: m.Faltan3DiasPage
})));
const Faltan2DiasPage = lazy(() => import('./pages/Faltan2DiasPage').then(m => ({
  default: m.Faltan2DiasPage
})));
const Faltan1DiaPage = lazy(() => import('./pages/Faltan1DiaPage').then(m => ({
  default: m.Faltan1DiaPage
})));
const Faltan3HrsPage = lazy(() => import('./pages/Faltan3HrsPage').then(m => ({
  default: m.Faltan3HrsPage
})));
const CoachingPage = lazy(() => import('./pages/CoachingPage').then(m => ({
  default: m.CoachingPage
})));
const CheckoutLloydPage = lazy(() => import('./pages/CheckoutLloydPage').then(m => ({
  default: m.CheckoutLloydPage
})));
const VipCallsPage = lazy(() => import('./pages/VipCallsPage').then(m => ({
  default: m.VipCallsPage
})));
const VslWhatsappPage = lazy(() => import('./pages/VslWhatsappPage').then(m => ({
  default: m.VslWhatsappPage
})));
const ThankYouOfferPage = lazy(() => import('./pages/ThankYouOfferPage').then(m => ({
  default: m.ThankYouOfferPage
})));
const ThankYouDownsalePage = lazy(() => import('./pages/ThankYouDownsalePage').then(m => ({
  default: m.ThankYouDownsalePage
})));
const CarSalesmanPage = lazy(() => import('./pages/CarSalesmanPage').then(m => ({
  default: m.CarSalesmanPage
})));
const NineToFivePage = lazy(() => import('./pages/NineToFivePage').then(m => ({
  default: m.NineToFivePage
})));
const CarSalesmanWebinarPage = lazy(() => import('./pages/CarSalesmanWebinarPage').then(m => ({
  default: m.CarSalesmanWebinarPage
})));
const EscapaDelDealershipGraciasPage = lazy(() => import('./pages/EscapaDelDealershipGraciasPage').then(m => ({
  default: m.EscapaDelDealershipGraciasPage
})));
const ThankYouDealershipPage = lazy(() => import('./pages/ThankYouDealershipPage').then(m => ({
  default: m.ThankYouDealershipPage
})));
const ConfirmationThankYouPage = lazy(() => import('./pages/ConfirmationThankYouPage').then(m => ({
  default: m.ConfirmationThankYouPage
})));
// Minimal loading screen matching the dark theme
function PageLoader() {
  return <div className="min-h-screen bg-black flex items-center justify-center" data-id="element-0">
      <div className="w-8 h-8 border-2 border-[#00f7fc]/30 border-t-[#00f7fc] rounded-full animate-spin" data-id="element-1" />
    </div>;
}
export function App() {
  useEffect(() => {
    // Global Facebook Pixel — fires on every page
    ;
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
  }, []);
  return <BrowserRouter data-id="element-2">
      <Suspense fallback={<PageLoader data-id="element-4" />} data-id="element-3">
        <Routes data-id="element-5">
          <Route path="/" element={<Navigate to="/meta-jueves" replace data-id="element-7" />} data-id="element-6" />
          <Route path="/meta-martes" element={<LandingPage data-id="element-9" />} data-id="element-8" />
          <Route path="/meta-jueves" element={<LandingPage data-id="element-11" />} data-id="element-10" />
          <Route path="/marca-el-gol" element={<LandingPage data-id="element-13" />} data-id="element-12" />
          <Route path="/meta-jueves-lp2" element={<LandingPage data-id="element-15" />} data-id="element-14" />
          <Route path="/meta-jueves-rr" element={<LandingPage data-id="element-17" />} data-id="element-16" />
          <Route path="/reregister" element={<LandingPage data-id="element-19" />} data-id="element-18" />
          <Route path="/jon-test" element={<LandingPage data-id="element-21" />} data-id="element-20" />
          <Route path="/en-vivo" element={<LandingPage data-id="element-23" />} data-id="element-22" />
          <Route path="/bienvenidos" element={<LandingPage data-id="element-25" />} data-id="element-24" />
          <Route path="/bienvenidos-m" element={<LandingPage data-id="element-27" />} data-id="element-26" />
          <Route path="/news-brake" element={<LandingPage data-id="element-29" />} data-id="element-28" />
          <Route path="/organic-martes" element={<LandingPage data-id="element-31" />} data-id="element-30" />
          <Route path="/organic-jueves" element={<LandingPage data-id="element-33" />} data-id="element-32" />
          <Route path="/yt-jueves" element={<LandingPage data-id="element-35" />} data-id="element-34" />
          <Route path="/webinar-jueves-new" element={<WebinarJuevesNewPage data-id="element-37" />} data-id="element-36" />
          <Route path="/thank-you" element={<ThankYouPage data-id="element-39" />} data-id="element-38" />
          <Route path="/thank-you-offer" element={<ThankYouOfferPage data-id="element-41" />} data-id="element-40" />
          <Route path="/thank-you-downsale" element={<ThankYouDownsalePage data-id="element-43" />} data-id="element-42" />
          <Route path="/thank-you-m" element={<ThankYouMPage data-id="element-45" />} data-id="element-44" />
          <Route path="/vsl" element={<VslPage data-id="element-47" />} data-id="element-46" />
          <Route path="/vsl-whatsapp" element={<VslWhatsappPage data-id="element-49" />} data-id="element-48" />
          <Route path="/vsl-disqualified" element={<VslDisqualifyPage data-id="element-51" />} data-id="element-50" />
          <Route path="/up-sell-disqualify" element={<UpSellDisqualifyPage data-id="element-53" />} data-id="element-52" />
          <Route path="/vsl-ig" element={<VslIgPage data-id="element-55" />} data-id="element-54" />
          <Route path="/optin-vsl" element={<OptinVslPage data-id="element-57" />} data-id="element-56" />
          <Route path="/retargeting" element={<RetargetingPage data-id="element-59" />} data-id="element-58" />
          <Route path="/purchase-book-a-call" element={<ConfirmationPage data-id="element-61" />} data-id="element-60" />
          <Route path="/purchase-book-a-call-webinar" element={<ConfirmationPage data-id="element-63" />} data-id="element-62" />
          <Route path="/llamadas-semanales-curso" element={<LlamadasSemanalesCursoPage data-id="element-65" />} data-id="element-64" />
          <Route path="/book-call-strategy" element={<BookCallStrategyPage data-id="element-67" />} data-id="element-66" />
          <Route path="/replay" element={<ReplayPage data-id="element-69" />} data-id="element-68" />
          <Route path="/lloyd" element={<LloydPage data-id="element-71" />} data-id="element-70" />
          <Route path="/checkout-lloyd" element={<CheckoutLloydPage data-id="element-73" />} data-id="element-72" />
          <Route path="/heylloyd" element={<HeyLloydPage data-id="element-75" />} data-id="element-74" />
          <Route path="/reply-webinar" element={<HeyLloydPage data-id="element-77" />} data-id="element-76" />
          <Route path="/webinar-reply" element={<WebinarReplyPage data-id="element-79" />} data-id="element-78" />
          <Route path="/in" element={<WebinarReplyPageIndia data-id="element-81" />} data-id="element-80" />
          <Route path="/book-call" element={<BookingQualificationPage data-id="element-83" />} data-id="element-82" />
          <Route path="/book-call-internal" element={<BookCallInternalPage data-id="element-85" />} data-id="element-84" />
          <Route path="/vip-calls" element={<VipCallsPage data-id="element-87" />} data-id="element-86" />
          <Route path="/llamada-ai" element={<LlamadaConfirmationPage data-id="element-89" />} data-id="element-88" />
          <Route path="/heylloyd-customs" element={<HeyLloydCustomsPage data-id="element-91" />} data-id="element-90" />
          <Route path="/heylloyd-book-a-call" element={<HeyLloydBookACallPage data-id="element-93" />} data-id="element-92" />
          <Route path="/infocommerce-book-a-call" element={<HeyLloydBookACallPage data-id="element-95" />} data-id="element-94" />
          <Route path="/privacy" element={<PrivacyPage data-id="element-97" />} data-id="element-96" />
          <Route path="/terms" element={<TermsPage data-id="element-99" />} data-id="element-98" />
          <Route path="/regalo" element={<RegaloPage data-id="element-101" />} data-id="element-100" />
          <Route path="/meditations" element={<MeditationsPage data-id="element-103" />} data-id="element-102" />
          <Route path="/llamada-confirmacion" element={<LlamadaConfirmationPage data-id="element-105" />} data-id="element-104" />
          <Route path="/vid1" element={<BreakoutVideoPage videoId="1173156247" title="¿Y si HEYLLOYD no funciona para mi nicho o tipo de negocio?" videoNumber={1} data-id="element-107" />} data-id="element-106" />
          <Route path="/vid2" element={<BreakoutVideoPage videoId="1173156261" title="Ya he invertido en otros programas y no me funcionaron. ¿Qué hace a este diferente?" videoNumber={2} data-id="element-109" />} data-id="element-108" />
          <Route path="/vid3" element={<BreakoutVideoPage videoId="1173156277" title="No tengo tiempo para implementar otro sistema complejo." videoNumber={3} data-id="element-111" />} data-id="element-110" />
          <Route path="/vid4" element={<BreakoutVideoPage videoId="1173156217" title="Me preocupa el costo de la inversión. ¿Cuál es el ROI real?" videoNumber={4} data-id="element-113" />} data-id="element-112" />
          <Route path="/vid5" element={<BreakoutVideoPage videoId="1173156206" title="¿No puedo simplemente hacer lo mismo con ChatGPT y otras herramientas gratuitas?" videoNumber={5} data-id="element-115" />} data-id="element-114" />
          <Route path="/replay-offer" element={<ReplayOfferPage data-id="element-117" />} data-id="element-116" />
          <Route path="/1050-7-dias" element={<CaseStudy1050Page data-id="element-119" />} data-id="element-118" />
          <Route path="/como-ia" element={<ComoIaPage data-id="element-121" />} data-id="element-120" />
          <Route path="/welcome" element={<WelcomePage data-id="element-123" />} data-id="element-122" />
          <Route path="/historia" element={<HistoriaPage data-id="element-125" />} data-id="element-124" />
          <Route path="/lead-magnet-heylloyd-demo" element={<LeadMagnetHeyLloydDemoPage data-id="element-127" />} data-id="element-126" />
          <Route path="/faltan-3-dias" element={<Faltan3DiasPage data-id="element-129" />} data-id="element-128" />
          <Route path="/faltan-2-dias" element={<Faltan2DiasPage data-id="element-131" />} data-id="element-130" />
          <Route path="/faltan-1-dia" element={<Faltan1DiaPage data-id="element-133" />} data-id="element-132" />
          <Route path="/faltan-3-hrs" element={<Faltan3HrsPage data-id="element-135" />} data-id="element-134" />
          <Route path="/coaching" element={<CoachingPage data-id="element-137" />} data-id="element-136" />
          <Route path="/car-salesman" element={<CarSalesmanPage data-id="element-139" />} data-id="element-138" />
          <Route path="/9-to-5" element={<NineToFivePage data-id="element-141" />} data-id="element-140" />
          <Route path="/car-saleman-webinar" element={<CarSalesmanWebinarPage data-id="element-143" />} data-id="element-142" />
          <Route path="/car-salesman-webinar" element={<CarSalesmanWebinarPage data-id="element-145" />} data-id="element-144" />
          <Route path="/escapa-del-dealership-gracias" element={<EscapaDelDealershipGraciasPage data-id="element-147" />} data-id="element-146" />
          <Route path="/thank-you-dealership" element={<ThankYouDealershipPage data-id="element-149" />} data-id="element-148" />
          <Route path="/confirmation-page" element={<ConfirmationThankYouPage data-id="element-151" />} data-id="element-150" />
          <Route path="*" element={<Navigate to="/meta-jueves" replace data-id="element-153" />} data-id="element-152" />
        </Routes>
      </Suspense>
    </BrowserRouter>;
}